import { render, staticRenderFns } from "./PPButtonToggleFullscreen.vue?vue&type=template&id=152d7a70&"
import script from "./PPButtonToggleFullscreen.vue?vue&type=script&lang=js&"
export * from "./PPButtonToggleFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../playmaker_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports